import { CallToActionsInstance, DailyProgramCta } from '../types/dailyProgram';

export const ARCHIVED_LABEL = '(archived)';

export interface MultiPropertyItemBase {
  property: string;
}

export interface MultiPropertyItem<T extends MultiPropertyItemBase> {
  properties: Array<T>;
  source?: string;
}

export interface MultiPropertyKind {
  status: 'brand' | 'multi' | 'property' | 'orphan';
  variant: 'ocean' | 'lime' | 'banana' | 'slate';
  icon: 'building' | 'house' | 'question';
}

export function getMultiPropertyKind<T extends MultiPropertyItem<MultiPropertyItemBase>>(
  item?: T
): MultiPropertyKind {
  const status =
    !item || !item.source
      ? 'brand'
      : item.properties.length > 1
        ? 'multi'
        : item.properties[0].property === item.source
          ? 'property'
          : 'orphan';

  return {
    status,
    variant:
      status === 'brand'
        ? 'ocean'
        : status === 'multi'
          ? 'banana'
          : status === 'property'
            ? 'lime'
            : 'slate',
    icon:
      status === 'brand' || status === 'multi'
        ? 'building'
        : status === 'property'
          ? 'house'
          : 'question',
  };
}

export const evaluateCallToActions = (
  sourceCtas: CallToActionsInstance,
  parentCtas: DailyProgramCta[]
): DailyProgramCta[] => {
  return sourceCtas.syncWithTemplate ? parentCtas : sourceCtas.values;
};
